export const subjectIDs: any = {
    1: "Math",
    2: "Science",
    3: "Physics",
    4: "Chemistry",
    5: "Biology"
};
